<template>
  <div
    :class="{'wishlist-area--active': showCartArea}"
    class="wishlist-area">
    <!-- CIRCLE ICON -->
    <div
      @click="$_toggleWishlist(true)"
      :class="{'wishlist-area__icon--active' : this.wishlist.length}"
      v-show="bottonCircleVisible"
      class="wishlist-area__icon">
      <svg width="26px" height="32px" viewBox="0 0 26 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Product-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Desktop-HD-Product-Page-hover-pulsante-aggiunto-alla-lista" transform="translate(-1340.000000, -857.000000)" stroke="#FFFFFF">
                <g id="noun_favourite_1000873" transform="translate(1340.000000, 858.000000)">
                    <g id="Group">
                        <g>
                            <path d="M15.2865111,0.430867877 L15.2865111,4.3216685 C15.2865111,4.93561983 15.8069931,5.43332582 16.449039,5.43332582 L20.5178516,5.43332582" id="Shape"></path>
                            <path d="M20.5178516,17.8250717 L20.5178516,5.89378734 C20.5178516,5.5989587 20.395372,5.31620527 20.1773581,5.10772923 L15.627009,0.756467637 C15.4089906,0.547989591 15.1132964,0.430867877 14.8049745,0.430867877 L1.9174037,0.430867877 C1.27535728,0.430867877 0.754875712,0.928573867 0.754875712,1.5425252 L0.754875712,24.8574749 C0.754875712,25.4714257 1.27535728,25.9691322 1.9174037,25.9691322 L12.1037412,25.9691322" id="Combined-Shape"></path>
                        </g>
                        <path d="M19.0655487,23.6952461 C19.0655487,21.7648753 20.4669801,20.2 22.3960618,20.2 C24.3251436,20.2 25.7978504,21.8420205 25.3459651,23.7186806 C24.87669,25.6675764 19.1467477,30.4419797 19.1467477,30.4419797 C19.1467477,30.4419797 13.1148907,25.9472585 12.6227344,23.7186806 C12.2064755,21.8337874 13.6435587,20.2 15.5726391,20.2 C17.5017195,20.2 19.0655487,21.7648753 19.0655487,23.6952461 Z" id="Shape"></path>
                        <path d="M16.8235294,13.1565217 L8.68983957,13.1565217" id="Shape"></path>
                        <path d="M16.8235294,10.3391304 L8.68983957,10.3391304" id="Shape"></path>
                        <path d="M16.8235294,15.973913 L8.68983957,15.973913" id="Shape"></path>
                        <path d="M6.5,13.1565217 L4.93582888,13.1565217" id="Shape"></path>
                        <path d="M6.5,10.3391304 L4.93582888,10.3391304" id="Shape"></path>
                        <path d="M6.5,15.973913 L4.93582888,15.973913" id="Shape"></path>
                    </g>
                </g>
            </g>
        </g>
      </svg>
      <div
        v-if="wishlist.length > 0"
        class="wishlist-area__icon__qty">{{ wishlist.length }}</div>
      <span
        v-if="slug !== undefined"
        @click="$_addToWishlist"
        class="wishlist-area__icon__add-to-box">
          {{ $t('wishlist.addToList') }}
      </span>
    </div>

    <!-- Listing Area -->
    <div
      v-display="{ showCartArea, step }"
      class="wishlist-area__cart">

      <div class="wishlist-area__cart__container" data-simplebar>

        <div class="wishlist-area__cart__contents">

          <!-- SLIDE01: cart area -->
          <div
            v-if="step === 0"
            class="wishlist-area__cart__contents__step wishlist-area__cart__contents__step--cart">
            <h3 
              v-html="$t('wishlist.yourCart')"
              class="wishlist-area__cart__contents__step__h3">
            </h3>
            <p
              v-if="wishlist.length > 0"
              class="wishlist-area__cart__contents__step__p"
              v-html="$t('wishlist.cartMessage')">
            </p>
            <p
              v-else
              class="wishlist-area__cart__contents__step__p"
              v-html="$t('wishlist.cartMessage2')">
            </p>
            <!-- Products list -->
            <ul>
              <li
                v-for="(slide, index) of wishlist"
                :key="index">
                  <router-link :to="{ name: `${lang}.single-product`, params: { slug: slide.fields.slug } }">
                    <img
                      :src="slide.fields.productThumbnail.fields.file.url + '?w=110&fit=scale'"
                      :alt="slide.fields.productThumbnail.fields.description"
                      :width="110"
                      :height="110">
                  </router-link>
                  <router-link :to="{ name: `${lang}.single-product`, params: { slug: slide.fields.slug } }">
                    <h3 v-html="slide.fields.title"/>
                  </router-link>
                  <p @click="$_removeFromWishlist(slide)">{{ $t('wishlist.remove') }}</p>
              </li>
            </ul>
            <p
              @click="$_goStep(1)"
              class="wishlist-area__cart__contents__step-next">
                {{ $t('wishlist.next') }}
            </p>
          </div>

          <!-- SLIDE02: form area -->
          <div
            v-if="step === 1"
            class="wishlist-area__cart__contents__step wishlist-area__cart__contents__step--form">
              <SendWishlist @success="$_goStep(2)" @failure="$_goStep(3)"/>
          </div>

          <div
            v-if="step === 2"
            class="wishlist-area__cart__contents__step wishlist-area__cart__contents__step--form">
            <h3 class="wishlist-area__cart__contents__step__h3" v-html="$t('forms.successTitle')"></h3>
            <p class="wishlist-area__cart__contents__step__p" v-html="$t('forms.successText')"></p>
          </div>

          <div
            v-if="step === 3"
            class="wishlist-area__cart__contents__step wishlist-area__cart__contents__step--form">
            <h3 class="wishlist-area__cart__contents__step__h3" v-html="$t('forms.failureTitle')"></h3>
            <p class="wishlist-area__cart__contents__step__p" v-html="$t('forms.failureText')"></p>
          </div>

        </div>
        <!-- fine wishlist-area__cart__contents -->

        <div class="wishlist-area__cart__footer">
          <!-- CLOSE -->
          <svg
            @click="$_toggleWishlist(false)"
            width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Product-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
                <g id="Desktop-HD-Product-Page-lista-aperta" transform="translate(-1334.000000, -855.000000)" stroke="#252525" stroke-width="2">
                    <g id="Group-6" transform="translate(1335.000000, 856.000000)">
                        <path d="M0.625140774,0.625140774 L23.3748592,23.3748592 L0.625140774,0.625140774 Z" id="Line-4"></path>
                        <path d="M0.625140774,23.3748592 L23.3748592,0.625140774 L0.625140774,23.3748592 Z" id="Line-4"></path>
                    </g>
                </g>
            </g>
          </svg>
          <!-- BACK -->
          <svg
            @click="$_goStep(0)"
            class="wishlist-area__cart__footer__back"
            width="39px" height="18px" viewBox="0 0 39 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Product-Pages" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Desktop-HD-Product-Page-lista-aperta-form" transform="translate(-1119.000000, -858.000000)" stroke="#979797">
                      <g id="Group" transform="translate(1138.656854, 866.292893) scale(-1, 1) rotate(-225.000000) translate(-1138.656854, -866.292893) translate(1124.156854, 851.792893)">
                          <path d="M14.9069995,32.9533219 L14.9069995,-4.11477706" id="Line-3" stroke-linecap="square" transform="translate(14.634450, 14.341557) scale(1, -1) rotate(45.000000) translate(-14.634450, -14.341557) "></path>
                          <polyline id="Path" points="13.8700577 1.17157288 1.87005769 1.17157288 1.87005769 13.1715729"></polyline>
                      </g>
                  </g>
              </g>
          </svg>
        </div>
        <!-- fine footer -->
      </div>
      <!-- fine wishlist-area__cart__container -->
    </div>
    <!-- fine wishlist-area__cart -->
  </div>
</template>

<script>

import SendWishlist from '@/components/WishlistArea/SendWishlist/SendWishlist.vue'
import 'simplebar' // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { TweenLite } from 'gsap/TweenLite'
import { TimelineLite } from 'gsap/TimelineLite'

import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'WishlistArea',
  mixins: [matchMedia],
  components: {
    SendWishlist
  },
  props: {
    slug: {
      type: String,
      required: false
    },
    showCartArea: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: false
    }
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters('wishlist', [
      'wishlist'
    ]),
    ...mapGetters('contentful', [
      'product'
    ]),
    ...mapGetters([
      'lang'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    bottonCircleVisible: {
      get () {
        if (this.showCartArea) return false
        if (this.slug === undefined && this.wishlist.length === 0) return false
        return true
      }
    },
    getViewPort: {
      get () {
        return this.matchMedia === 'small'
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    ...mapMutations('wishlist', [
      'addToWishlist',
      'removeFromWishlist',
      'clearWishlist'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_addToWishlist () {
      this.addToWishlist(this.currentProduct)
      this.$emit('open-wishlist')
      this.$emit('change-step', {step: 0})
    },
    $_removeFromWishlist (element) {
      this.removeFromWishlist(element)
      if (this.wishlist.length === 0) this.$emit('close-wishlist')
    },
    $_toggleWishlist (check) {
      if (check) this.$emit('open-wishlist')
      else this.$emit('close-wishlist')
    },
    $_createTimeLine (el, showCartArea, step) {
      const tl = new TimelineLite({
        // onComplete: () => tl.kill()
      })
      if (showCartArea) {
        if (step !== 1) {
          // nascondo il back
          tl.to(el.querySelector('.wishlist-area__cart__footer__back'), 0.4, { opacity: 0 })
        }
        if (this.getViewPort) tl.to(el, 0, { width: '100%', height: '100vh' })
        else tl.to(el, 0.4, { width: '322px', height: '80vh' })
        tl.to(el.querySelector('.wishlist-area__cart__contents__step h3.wishlist-area__cart__contents__step__h3'), 0.4, { opacity: 1, y: 0 })
        tl.to(el.querySelector('.wishlist-area__cart__contents__step p.wishlist-area__cart__contents__step__p'), 0.4, { opacity: 1, y: 0 })
        if (step === 0) {
          const items = el.querySelectorAll('li')
          for (var i = 0; i < items.length; i++) {
            tl.to(items[i], 0.2, { opacity: 1, x: 0 })
          }
          if (this.wishlist.length) {
            el.querySelector('.wishlist-area__cart__contents__step-next').style.visibility = 'visible'
            tl.to(el.querySelector('.wishlist-area__cart__contents__step-next'), 0.4, { opacity: 1 })
          } else el.querySelector('.wishlist-area__cart__contents__step-next').style.visibility = 'hidden'
        } else if (step === 1) {
          tl.to(el.querySelector('.wishlist-area__cart__contents__step p.wishlist-area__cart__contents__step__p2'), 0.4, { opacity: 1, y: 0 })
          tl.to(el.querySelector('.send-wishlist form'), 0.6, { opacity: 1, y: 0 })
          // mostro il back
          tl.to(el.querySelector('.wishlist-area__cart__footer__back'), 0.4, { opacity: 1 })
        }
        tl.to(el.querySelector('.wishlist-area__cart__footer'), 0.4, { opacity: 1 })
      } else {
        const items = el.querySelectorAll('li')
        tl.to(el.querySelector('.wishlist-area__cart__footer'), 0.2, { opacity: 0 }, '-=0.2')
        if (step === 0) {
          tl.to(el.querySelector('.wishlist-area__cart__contents__step-next'), 0.2, { opacity: 0 }, '-=0.4')
          for (var j = items.length - 1; j >= 0; j--) {
            tl.to(items[j], 0.2, { opacity: 0, x: '-8px' }, '-=0.2')
          }
          tl.to(el.querySelector('.wishlist-area__cart__footer__back'), 0.2, { opacity: 0 })
        } else if (step === 1) {
          tl.to(el.querySelector('.send-wishlist form'), 0.2, { opacity: 0, y: '20px' })
          tl.to(el.querySelector('.wishlist-area__cart__contents__step p.wishlist-area__cart__contents__step__p2'), 0.2, { opacity: 0, y: '20px' })
          tl.to(el.querySelector('.wishlist-area__cart__footer__back'), 0.2, { opacity: 1 })
        }
        tl.to(el.querySelector('.wishlist-area__cart__contents__step p.wishlist-area__cart__contents__step__p'), 0.2, { opacity: 0, y: '20px' })
        tl.to(el.querySelector('.wishlist-area__cart__contents__step h3.wishlist-area__cart__contents__step__h3'), 0.2, { opacity: 0, y: '20px' })
        if (this.getViewPort) tl.to(el, 0, { width: 0, height: 0 })
        else tl.to(el, 0.2, { width: 0, height: 0 })
      }
      return tl
    },
    $_goStep (step) {
      this.$emit('change-step', {step: step})
      if (step === 2) this.clearWishlist()
    }
  },
  directives: {
    'display': {
      inserted (el, binding) {
        TweenLite.to(el, 0, { width: '0%', height: '0%' })
      },
      componentUpdated (el, binding, vnode) {
        const { showCartArea, step } = binding.value
        const timeline = vnode.context.$_createTimeLine(el, showCartArea, step)
        el.querySelector('.simplebar-content').scrollTop = 0
        timeline.play()
        // timeline.kill()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
